class DatingStats {

  constructor() {

    if (!this.setVars())
      return

    this.setEvents()

  }

  setVars() {

    this.section = document.querySelector('.datingStats')

    if (!this.section)
      return

    this.buttons = this.section.querySelectorAll('.datingStats__button')
    this.submit  = this.section.querySelector('.datingStats__submit')

    return true

  }

  setEvents() {

    this.buttons.each((item, index) => {

      item.addEventListener('click', (e) => {
      
        e.preventDefault()
        this.changeUrl(index)
      
      })

    })

  }

  changeUrl(index) {

    this.buttons.removeClass('datingStats__button--active')
    this.buttons[index].addClass('datingStats__button--active')

    const url = this.buttons[index].getAttribute('data-url')
    this.submit.setAttribute('href', url)

  }

}